/**
 * Starter labels for nonprofit / multi-state filing knowledge bases.
 * Inserted once per user (see DocumentsPage) when they have no tags yet.
 */
export const SUGGESTED_NONPROFIT_KNOWLEDGE_TAG_NAMES: string[] = [
  '501(c)(3)',
  'Form 990',
  'Form 1023 / exemption application',
  'State charity registration',
  'Annual report (state)',
  'Bylaws & governance',
  'Conflict of interest policy',
  'Fundraising & charitable solicitation (URS)',
  'IRS determination letter',
  'California filings',
  'New York filings',
  'Texas filings',
  'Multi-state compliance',
  'Sales & use tax exemption',
  'Registered agent',
];

export const KB_SUGGESTED_TAGS_SEEDED_STORAGE_KEY = (userId: string) =>
  `sop-ai:kb-suggested-tags-seeded:${userId}`;
